export default __webpack_public_path__ + "static/media/SL.1dea837f.svg";